import { useState } from "react"
import { Button } from "../../../components/button/Button"
import { Sidepanel } from "../../../components/sidepanel/Sidepanel"
import { exportMonth } from "../../../fetch/export"
import { useWatcher } from "@/lib/state/useWatcher"
import { userState } from "@/store/user"
import { hasUserAccess } from "@/utils/user"
import { UserRole } from "src/types"
import { Label } from "@/components/ui/label"
import { DatePicker } from "@/components/datepicker/DatePicker"
import { formatDate } from "@/lib/formatDate"
import styled from "styled-components"

const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
`
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
`

const date = new Date()
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)

export const Export = () => {
  const [showExportModal, setShowExportModal] = useState(false)
  const [from, setFrom] = useState<string | undefined>(formatDate(firstDay))
  const [to, setTo] = useState<string | undefined>(formatDate(new Date()))
  const user = useWatcher(userState)

  const startExport = () => {
    if (from && to) {
      exportMonth(from, to)
    }
  }
  return hasUserAccess({
    neededRole: UserRole.Manager,
    userRole: user.role,
  }) ? (
    <>
      <Sidepanel
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
      >
        <Wrap>
          <Title>Eksportēt</Title>
          <span>
            <Label>Datums no:</Label>
            <DatePicker value={from} onChange={(d) => setFrom(d)} />
          </span>
          <span>
            <Label>Datums līdz:</Label>
            <DatePicker value={to} onChange={(d) => setTo(d)} />
          </span>
        </Wrap>
        <Button onClick={startExport}>Eksportēt</Button>
      </Sidepanel>
      <Button
        onClick={() => setShowExportModal(true)}
        style={{ marginRight: 8 }}
        variant="secondary"
      >
        Eksportēt
      </Button>
    </>
  ) : null
}
